import { useSelector } from "react-redux";
import { AppRemoteConfigAndValuesMap } from "../../central-atoms/org-app-map/types";
import { APP_STATE, MainState } from "../../types";

export const useRemoteConfig = (): AppRemoteConfigAndValuesMap => {
  return useSelector((state: APP_STATE) => (state.main as MainState)?.app?.remoteConfig || {});
};
